<template>
  <div>
    <transition mode="out-in" name="fade">
      <image-modal @close="showModal = false" :mediaId="currentMediaId" v-if="showModal" />
    </transition>
    <div class="gallery">
      <div v-if="!media.hasOwnProperty('.value')">
        <draggable class="columns is-multiline" v-model="gallery.images">
          <template v-for="(img, key) in gallery.images" v-if="img">
            <div class="column is-narrow" :key="key">
              <div class="gallery-image-container">
                <div @click="showImage(img)">
                  <GalleryImage :media="media" :imageID="img" :thumb-size="480"></GalleryImage>
                </div>
                <a class="gallery-image-delete button is-small is-danger is-rounded" @click="deleteImage(img)">
                          <span class="icon is-small">
                            <i class="fas fa-trash"></i>
                          </span>
                </a>
                <div class="gallery-image-drag"></div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import GalleryImage from './GalleryImage'
import draggable from 'vuedraggable'
import ImageModal from '../../shared/ImageModal'

export default {
  props: [ 'media', 'gallery' ],
  data () {
    return {
      showModal: false,
      currentMediaId: null
    }
  },
  methods: {
    deleteImage (key) {
      let i = this.gallery.images.indexOf(key)
      if (i > -1) {
        this.gallery.images.splice(i, 1)
      }
    },
    showImage (key) {
      this.currentMediaId = key
      this.showModal = true
    }
  },
  components: {
    GalleryImage,
    draggable,
    ImageModal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery {
    margin: 16px;
  }
  .gallery-image-container {
    position: relative;
    .gallery-image-delete {
      position: absolute;
      top: 10%;
      right: 10%;
    }
    .gallery-image-drag {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 30px 30px;
      border-color: transparent transparent rgba(#fff, 0.75) transparent;
      cursor: pointer;
      /*box-shadow: 0 1px 1px 0 #000;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/GalleryImages.vue